import {
  diaChiSearchColumns,
  phuongThucGiaoHangSearchColumns,
  phuongThucThanhToanSearchColumns,
  phuongThucVanChuyenSearchColumns,
  QUERY_KEYS
} from '@/constants';
import { DiaChi, PhuongThucGiaoHang, PhuongThucThanhToan, PhuongTienVanChuyen } from '@/types/schemas';
import { FileSelectField, FormField, SearchField } from '@/components/custom/erp';
import { FormFieldActions, FormFieldState } from '../../hooks';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export function OtherTab({ formMode, formState: { state, actions } }: OtherTabProps) {
  return (
    <div className='p-4'>
      <div className='flex items-center'>
        <FileSelectField
          label='Chọn file'
          formMode={formMode}
          labelClassName='w-32'
          onFileChange={file => console.log(file)}
        />
      </div>
    </div>
  );
}
